export class Hotel {
  id: number;
  code: string;
  name: string;
  address: string | null;
  city_id: number | null;
  country_id: number | null;
  country_name?: string | null;
  post_code: string | null;
  email: string | null;
  website: string | null;
  category_id: number | null;
  hotel_chain_id: number | null;
  logo_url: string | null;
  star_level: number | null;
  currency_id: number | null;
  currency_name?: string | null;
  currency_code?: string | null;
  is_shared_guest_data: boolean | null;
  last_modified: Date | null;
  last_modified_by: number | null;
  created: Date | null;
  created_by: number | null;
  phone_number: string | null;
  city_name: string | null;
  tax_identification_number: string | null;
  sidebar_menu_logo_url: string | null = null;
  show_sidebar_menu_logo: boolean = false;
  company_name: string | null;
  company_header_info: string | null;
  company_logo_image_url: string | null;
}

export class HotelConsolidation {
  id = 0;
  hotel_id: number;
  target_hotel_id: number;
  target_hotel_name: string;
}
